/**
 * Overlay Area Dynamic Fields Handler
 * Shows/hides custom area fields based on selected variant
 */

if (!window.OverlayAreaDynamicInitialized) {
  window.OverlayAreaDynamicInitialized = true;

  class OverlayAreaDynamic {
    constructor() {
      this.init();
    }

    init() {
      // Listen to the theme's variant:update event
      document.addEventListener("variant:update", (event) => {
        if (event.detail && event.detail.resource) {
          this.updateCustomAreaFields(event.detail.resource);
        }
      });

      // Also listen to variant:selected for immediate feedback
      document.addEventListener("variant:selected", () => {
        setTimeout(() => this.checkInitialVariant(), 50);
      });

      // Check initial state on load
      this.checkInitialVariant();
    }

    checkInitialVariant() {
      const variantPickers = document.querySelectorAll("variant-picker");
      variantPickers.forEach((picker) => {
        const selectedVariantData = picker.querySelector(
          'script[type="application/json"]',
        );
        if (selectedVariantData) {
          try {
            const variant = JSON.parse(selectedVariantData.textContent);
            if (variant) {
              this.updateCustomAreaFields(variant);
            }
          } catch (e) {
            console.error("Error parsing variant data:", e);
          }
        }
      });
    }

    updateCustomAreaFields(variant) {
      if (!variant) return;

      // Check metafield to determine if custom area fields should show
      // Fallback to title check if metafield is not available
      let isCustomArea =
        variant.metafields?.custom?.requires_custom_area === true ||
        variant.metafields?.custom?.requires_custom_area === "true";

      // Fallback: if metafield not available, check title
      if (!isCustomArea && variant.title) {
        const variantTitle = variant.title.toLowerCase().trim();
        isCustomArea = variantTitle.includes("custom area");
      }

      const needsCustomQuote = variant.price === 0;

      // Debug logging
      console.log("Variant:", variant.title);
      console.log(
        "Metafield value:",
        variant.metafields?.custom?.requires_custom_area,
      );
      console.log("Is custom area:", isCustomArea);
      console.log("Needs custom quote:", needsCustomQuote);

      // Find all overlay input wrappers
      const wrappers = document.querySelectorAll(".overlay-inputs-wrapper");

      wrappers.forEach((wrapper) => {
        const areaInputDiv = wrapper.querySelector(".overlay-area-input");
        const fileInputDiv = wrapper.querySelector(".overlay-file-input");
        const quoteNoticeWrapper = wrapper.querySelector(
          ".custom-quote-notice-wrapper",
        );
        const areaInputField = wrapper.querySelector(".overlay-area-field");

        if (isCustomArea) {
          // Show custom area fields
          if (areaInputDiv) areaInputDiv.style.display = "block";
          if (fileInputDiv) fileInputDiv.style.display = "block";
          if (areaInputField)
            areaInputField.setAttribute("required", "required");
        } else {
          // Hide custom area fields
          if (areaInputDiv) areaInputDiv.style.display = "none";
          if (fileInputDiv) fileInputDiv.style.display = "none";
          if (areaInputField) areaInputField.removeAttribute("required");
        }

        // Show custom quote notice if price is $0
        if (quoteNoticeWrapper) {
          quoteNoticeWrapper.style.display = needsCustomQuote
            ? "block"
            : "none";
        }
      });
    }
  }

  // Initialize on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      new OverlayAreaDynamic();
    });
  } else {
    new OverlayAreaDynamic();
  }
}
